import { format } from "date-fns";

export function requestQueryDateParser(date: Date): string {
  return format(date, "yyyy-MM-dd");
}
